import React, { Component, PropTypes } from 'react';
import { observer, inject } from 'mobx-react';
import { observable, autorun, action, toJS } from 'mobx';
import Spinner from '../../Spinner';
import DataTable from '../../DataTable';
import {Link} from 'react-router';

@inject('dataExportStore', 'reportingTemplateStore')
@observer
class DataExportList extends Component {
  static propTypes = {
    route: PropTypes.shape().isRequired,
    // params: PropTypes.shape({
    //   id: PropTypes.string.isRequired,
    // }).isRequired,
  };

  static contextTypes = {
    router: PropTypes.shape().isRequired,
    notify: PropTypes.shape().isRequired,
  };


  dispose;

  componentWillMount() {
    const { dataExportStore, reportingTemplateStore } = this.props;
    if (!dataExportStore.items.length) dataExportStore.fetchItems();
    if (!reportingTemplateStore.items.length && !reportingTemplateStore.isLoading) reportingTemplateStore.fetchItems();
  }

  columns = [
    { key: 'id', label: 'ID' },
    { key: 'name', label: 'Name' },
    { key: 'description', label: 'Description' },
    { key: 'protocol', label: 'Protocol' },
    { key: 'run', label: '' }
    // {key: 'formatter', label: 'Formatter'},
    // {key: 'location', label: 'Location'},
  ];

  slug = 'export/data-export';

  @action handleDelete = (idOrIds) => {
    const { notify } = this.context;
    console.log('handleDelete', idOrIds);
    this.props.dataExportStore.removeItems(idOrIds)
      .then(notify.success)
      .catch(notify.error);
  };

  render() {
    const { dataExportStore } = this.props;
    if(dataExportStore.isLoading) return <Spinner/>;

    let data = dataExportStore.items.map(item => {
      let protocol = dataExportStore.protocolOptions.find(p => +p.id === +item.protocol);
      return(
        Object.assign(
          {},
          item,
          { 
            protocol: protocol.name,
            run: [1,2].indexOf(protocol.id) > -1 ? <Link to={`${this.slug}/${item.id}/run`}>Run</Link> : '' // ftp, fs
          }
        )
      )
    });

    return (
      <div>
        <DataTable
          data={data}
          slug={this.slug}
          columns={this.columns}
          onDelete={this.handleDelete}
          allowAdd
          allowEdit
          allowDelete
          resource='data-delivery'
          isLoading={dataExportStore.isLoading}
        />
        {this.props.children}
      </div>
    );
  }
}

export default DataExportList;



// WEBPACK FOOTER //
// ./src/components/DataDelivery/DataExport/DataExportList.js